<template>
  <span class="panel-toolbar-count-badge">
    <slot />
  </span>
</template>

<script>
export default {
  //
}
</script>
